'use strict';

var rollbar = require('../rollbar');

if ((typeof window !== 'undefined') && !window._rollbarStartTime) {
  window._rollbarStartTime = (new Date()).getTime();
}

module.exports = rollbar;



//////////////////
// WEBPACK FOOTER
// ./src/browser/bundles/rollbar.noconflict.js
// module id = 1
// module chunks = 0